module.exports = __webpack_public_path__ + "img/logo_1880.dfa1c94.webp";